import { Box, Container, Stack, Typography } from '@mui/material';
import ProgressIndicator from './ProgressIndicator';
import { useContext } from 'react';
import { ActivityContext } from '@/contexts/ActivityContext';
import PreviousButton from './PreviousButton';
import { ActivityFormContext } from '@/contexts/ActivityFormContext';
import { useTranslation } from 'react-i18next';

const CreateActivityHeader = () => {
  //toDo move back button to own component
  const { activity } = useContext(ActivityContext);
  const { current } = useContext(ActivityFormContext);
  const { t } = useTranslation();

  return (
    <>
      {!current.noHeader && (
        <Container>
          <Stack alignItems="center" spacing={2} marginY={2}>
            <Stack direction="row" sx={{ width: '100%' }} justifyContent="space-between">
              <PreviousButton />
              <Typography variant="h6" sx={{ flex: 1, textAlign: 'center', padding: 0.5 }}>
                {t('Create activity')}
              </Typography>
            </Stack>
            <ProgressIndicator />
            {/* Rubriken finns bara när det finns ett namn — en tom <h> är en
                rubrik utan innehåll för skärmläsare. Raden behåller sin höjd. */}
            {!current.noActivityName && activity?.activityName ? (
              <Typography variant="h6" sx={{ wordBreak: 'break-word', minHeight: '1lh' }}>
                {activity.activityName}
              </Typography>
            ) : (
              <Box aria-hidden sx={{ minHeight: '1lh' }} />
            )}
          </Stack>
        </Container>
      )}
    </>
  );
};

export default CreateActivityHeader;
